export default {
    computed: {
       postBoosts() {return this.$store.getters.getCurrentPostBoosts }
    }
}